// import _ from 'lodash';

const categories = {
  list: {},
  categoryList: {},
}
const CategoriesReducer = function (state = categories, action) {
  switch (action.type) {
    case 'UPDATE_CATEGORIES_LIST': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      return {
        ...state,
        list: {
          ...state.list,
          ...newList,
        },
      }
    }

    case 'UPDATE_CATEGORIES_LIST_ORDER_TEMPLATE': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      return {
        ...state,
        categoryList: {
          ...state.list,
          ...newList,
        },
      }
    }

    default: {
      return state
    }
  }
}

export default CategoriesReducer
